import React from 'react'
import { Navbar } from '../../Navbar'
import AddNewAdjustment from './AddNewAdjustment'
import AdjustmentCashflowWorking from './AdjustmentCashflowWorking'

///////////////////////////////////////////////////////////////////////////
import workSpaceCss from "../../../myfin_v2/css/workSpaceOverView.module.css"
import sidemenucss from "../../../myfin_v2/css/sidemenu.module.css";
// import FSSideMenu from "../../myfin_v2/components/fs/FSSideMenu";
// import FSTopBar from "../../myfin_v2/components/fs/FSTopBar";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css"
import { motion } from "framer-motion";
import commoncss from "../../../myfin_v2/css/common.module.css"
import { Tabs, Tab, Typography, Box } from "@mui/material";
import buttoncss from "../../../myfin_v2/css/button.module.css"
import {Button} from "../../../myfin_v2/elements/Button";
import FSCss from "../../../myfin_v2/css/overview.module.css"
import loanCss from "../../../myfin_v2/css/overview.module.css"
import {ReactComponent as Plus} from "../../../myfin_v2/assets/icons/plus.svg"
import {ReactComponent as GreenDot} from "../../../myfin_v2/assets/icons/greenDotSmall.svg"
// import {ReactComponent as GreenDot} from "../../../myfin_v2/assets/icons/greenDotSmall.svg"
import {ReactComponent as LeftArrowIcon} from "../../../myfin_v2/assets/icons/left_arrow.svg"
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../../myfin_v2/elements/Sidebar';
import bookclosuretablecss from "../../../myfin_v2/css/adjustmentTable.module.css";
import tablecss from "../../../myfin_v2/css/table.module.css";
import Loading from '../../Common/Loader/Loading';
// import { Navbar } from '../../Navbar'
import moment from 'moment';
import  { useEffect, useState } from 'react'
import { useHistory } from 'react-router';
import swal from 'sweetalert';
import { addAdjustmentHeader, addAdjustmentItem, addNewOption, getAdjustmentOptions, removeAdjustmentHeader } from '../../../services/api/StandAlone/cashFlow';


const CashFlowAdjustment = () => {
     const [workingId, setWorkingId] = useState('');
      const [logsData, setLogsData] = useState([]);
       const history = useHistory();
         const [loading, setLoading] = useState(false);
          const user = JSON.parse(localStorage.getItem('user'));
             const tb_id = localStorage.getItem('tb_id');
             const [adjData, setAdjData] = useState([]);
              const project_id = localStorage.getItem('project_id');
       

         
         
             const AddNew = () => {
                 if(user.responsibilities === "view"||user.responsibilities === "approver"){
                     swal("Warning","You don't have access to add newLineItems","warning");
                     return false;
                 }
                 setLoading(true);
                 addAdjustmentHeader(project_id, tb_id).then(response => {
                     setAdjData(response.data.data);
                 }).catch(err => {
                     swal("Error", err, "error");
                 }).finally(() => setLoading(false));
             }

         const dispatch = useDispatch();
              const menuItems = [
              { label: "Balance Sheet", value: "Balance Sheets" , pagelink: "/financialstatement"},
              { label: "P&L Statement", value: "P&L Statement", pagelink: "/financialstatement"},
              { label: "CashFlow", value: "CashFlow", pagelink: "/financialstatement"},
              { label: "SOCIE", value: "SOCIE", pagelink: "/financialstatement"},
              { label: "General Notes", value: "General Notes", pagelink: "/financialstatement"},
              { label: "Balance Sheet Notes", value: "Balance Sheet Notes", pagelink: "/financialstatement"},
              { label: "PNL Statement Notes", value: "PNL Statement Notes", pagelink: "/financialstatement"},
              { label: "Disclosures", value: "Disclosures", pagelink: "/financialstatement"},
              { label: "Disclosures Checklist", value: "Disclosures Checklist", pagelink: "/financialstatement"},
            ];
          
               const FSSideMenu = ({ menuItems, title, activeItem, activeItemSubMenu }) => {
                    const dispatch = useDispatch();
                    console.log("activeItem",activeItem);
                    console.log("menuItems", menuItems);
                    const [openSubmenu, setOpenSubmenu] = useState(activeItem);
                  
                    const routerHistory = useHistory();
                  
                    const handleClick = (Link) => {
                      if (Link) {
                        routerHistory.push(Link);
                      }
                    };
                  
                    return (
                      <div
                        className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
                      >
                        <div className={sidemenucss.sidemenuHeader}     style={{ minHeight: "15vh" }}>
                          <span className={sidemenucss.sidemenuTitle}>{title}</span>
                          {/* <span className={sidemenucss.sidemenuSubTitle}>workspace name</span> */}
                        </div>
                        <div
                          className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} pt-0`}
                        >
                          <ul className={sidemenucss.sidemenuList}>
                            {menuItems.map((item, index) => (
                              <div key={index}>
                                <li
                                  // onClick={() => {
                                  //   // Toggle submenu visibility if the item has submenus
                                  //   if (item.subMenu) {
                                  //     setOpenSubmenu(openSubmenu === item.label ? null : item.label);
                                  //   } else {
                                  //     // Navigate if it's a top-level item without submenus
                                  //     handleClick(item.pagelink);
                                  //   }
                                  // }}
                                  // onClick={() => dispatch({ type: "NOTE_KEY", payload: index })}
                                   onClick={() => {
                  dispatch({ type: "NOTE_KEY", payload: index });
                  handleClick(item.pagelink || "/financialstatement");
                }}
                                  className={`${sidemenucss.sidemenuItem} ${
                                    activeItem === index
                                      ? sidemenucss.sidemenuItemActive
                                      : ""
                                  }`}
                                >
                                  <span className={sidemenucss.sidemenuItemname}>
                                    <div className={sidemenucss.sideMenuItemContainer}>
                                      {item.label}
                                    </div>
                                  </span>
                                </li>
                  
                                {item.subMenu && openSubmenu === item.label && (
                                  <div className={sidemenucss.submenuContainer}>
                                    {item.subMenu.map((sub, idx) => (
                                      <div
                                        key={idx}
                                        className={`${sidemenucss.submenuItem} ${
                                          activeItemSubMenu === sub.label
                                            ? sidemenucss.activeSubMenu
                                            : null
                                        }`}
                                        onClick={() => handleClick(sub.pagelink)}
                                      >
                                        {sub.label}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </ul>
                        </div>
                      </div>
                    );
                  };
                  
                  const FSTopBar = ({
                          // setLoanUploadModal,
                          ShowInDecimals,
                          setShowInDecimals,
                          //  history,
                          softDeletedData,
                          deleteItemsModel,
                          setDeleteItemsModal,
                          handleDelete,
                          setHandleDelete
                      }) => {
                          const history=useHistory();
                      return(
                          
                          <div className={FSCss.w100}>
                  
                              <div className={FSCss.uploadLoansMainContainer}>
                              
                              </div>
                  
                              <div className={FSCss.listPageheader}>
                                  <div className={FSCss.headerLeftContainer}>
                                      {/* <div className={FSCss.heading}>Loan Listing</div> */}
                                      {/* <div className={FSCss.heading}  > */}
                                          
                                          <div className={FSCss.iconContainer}>
                                              {/* <SearchIcon/> */}
                                              <LeftArrowIcon className="clickable"
                                              //   onClick={redirectToBookClosureHome}
                                               onClick={() => {dispatch({ type: "NOTE_KEY", payload: 2 }); history.push(`/financialstatement`) }}
                                              />
                                          </div>
                                          <div className={FSCss.topBarHeading}>Cashflow Workings</div>
                                           <div className={FSCss.iconDotContainer}>
                                              {/* <SearchIcon/> */}
                                              <GreenDot/>
                                          </div>
                                          <div className={FSCss.topBarSubHeading}>Add New Adjustments</div>
          
                                      {/* </div> */}
                                  </div>
                                  <div className={FSCss.headerRightContainer}>
                                      
                                      {/* <div className={FSCss.filterContainer}>
                                          <FilterIcon />
                                      </div> */}
                  
                                      {/* <div className={FSCss.filterContainer}>
                                          <span className="module-toggles">
                                              <div className="toggle-item">
                                                  <div className="toggle-container">
                                                      <label className="switch">
                                                          <input
                                                              type="checkbox"
                                                              checked={ShowInDecimals}
                                                              // onChange={() => setShowInDecimals(!ShowInDecimals)}
                                                          />
                                                          <span className="slider round"></span>
                                                      </label>
                                                  </div>
                                              </div>
                                          </span>
                                          {/* &nbsp; */}
                                          {/* &nbsp; */}
                                          {/* Ind AS Impact */}
                                          {/* <span className={FSCss.decimalLabel}>Show in Decimals</span>
                                      </div>  */}
                  
                                      {/* <div className={FSCss.calenderContainer}>
                                          <div className={FSCss.leftCalenderContainer}>
                                              <div className={FSCss.calenderLabels}>
                                                  From
                                              </div>
                                              <div className={FSCss.calenderDate}>
                                                  01-01-2024
                                              </div>
                                              <div className={FSCss.calenderIconContainer}>
                                                  <CalenderIcon />
                                              </div>
                                          </div>
                  
                                          <div className={FSCss.RightCalenderContainer}>
                                              <div className={FSCss.calenderLabels}>
                                                  To 
                                              </div>
                                              <div className={FSCss.calenderDate}>
                                                  01-03-2024
                                              </div>
                                              <div className={FSCss.calenderIconContainer}>
                                                  <CalenderIcon />
                                              </div>
                                          </div>
                                      </div> */}
                                      {/* <div className={FSCss.TopbtnWrapper}>
                                          <button
                                              onClick={() => {setLoanUploadModal(true);}} 
                                              type="button" 
                                              className={FSCss.linkRegisterButton}> 
                                              
                                           
                                              Link Registers
                                          </button>
                                      </div>
                                      <div className={FSCss.TopbtnWrapper}>
                                          <button
                                              onClick={() => {setLoanUploadModal(true);}} 
                                              type="button" 
                                              className={FSCss.FinalseBtn}> 
                                              
                                              Finalise FS
                                          </button>
                                      </div> */}
                                      {/* <Button
                                  btnColor={buttoncss.secondary}
                                  label="Adjustment Log"
                                  // onClick={() => {
                                  //     // history.push('/link-register')
                                  // //   handleNew();
                                  // }}
                                   onClick={() => history.push('/financialstatement/cashflow/adjustment-log')}
                                /> */}
                                  {/* &ensp; */}
                                 {/* <Button
                                    btnColor={buttoncss.primary}
                                    label="Add New Adjustment"
                                  //   onClick={handleFilter}
                                  //  onClick={() => {
                                  //     history.push('/finalize-fs')
                                  // //   handleNew();
                                  // }}
                                  
                                  />  */}
                                    <div className={loanCss.btnWrapper}>
                                                          <button
                                                            
                                                            //   onClick={() => history.push('/financialstatement/cashflow/add-new-adjustment')}
                                                            onClick={AddNew}
                                                            
                                                              type="button" 
                                                              style={{minWidth: '9rem'}}
                                                              className={loanCss.uploadPrimaryBtn}> 
                                                              <Plus className={`${loanCss.plusIcon}`} /> 
                                                             
                                                              Add New Item
                                                          </button>
                                                      </div>
                                  
                                  </div>
                              </div>
                          </div>
                      )
                  };
    return (
        <>


              <div className={`${workSpaceCss.df}`} >
                                            <Sidebar />
                                            <div className={`d-flex ${commoncss.pageContent}`}>
                                              <motion.div
                                                initial={{ x: -100, opacity: 0 }}
                                                animate={{ x: 0, opacity: 1 }}
                                                exit={{ x: 100, opacity: 0 }}
                                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                              >
                                                <FSSideMenu title="Financial Statements" menuItems={menuItems} activeItem={2} />
                                              </motion.div>
                                              <div className={bookclosurecss.bookClosureContent}>
                                                <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
                                                  <FSTopBar  />
                                                   {
                                            loading ? <Loading /> :
                                               
                                                     <div style={{height: "88vh", overflow: "auto"}} className='p-4'>
            
                                                     <AdjustmentCashflowWorking /> 
                                                  
                                                </div>
                                        }
                                                </div>
                                               
                                              </div>
                                            </div>
                                    
                                          </div>
            
                       
                        
                        
            
                   
            {/* <Navbar text="Financial Year: 2021 - 2022" />

            <AddNewAdjustment />
            <AdjustmentCashflowWorking /> */}
        </>
    )
}

export default CashFlowAdjustment